import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getAviationForecast } from "@features/Weather/services";
import { weatherWidgets, weatherWarningWidgets } from "@widgets/registry";
import { useIataContext } from "@contexts/IataContext";
import PageLayout from "./PageLayout/PageLayout";
const WeatherPage = () => {
    const { t } = useTranslation();
    const { iata } = useIataContext();
    const { data: aviationForecast, } = useQuery({
        queryFn: () => getAviationForecast(iata),
        queryKey: ["getAviationForecast"],
    });
    return (_jsx(PageLayout, { title: t("pages.weather.title"), description: t("pages.weather.description"), widgets: aviationForecast ? weatherWarningWidgets : weatherWidgets }));
};
export default WeatherPage;
